
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useLayoutEffect, useState } from 'react';
import { ComplaintType } from '../../typings/complaint';
import { getComplaintsType } from "../../services/questionService";
import Loader from 'react-loader-spinner';
import ComplaintTypeSelect from '../ComplaintTypeSelect';
import styles from "./modal.module.css"
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';

export type ActionModalProps = {
    headerTitle: string;
    contentTitle: string;
    onNext: any;
    primaryButtonText: string;
    seconderyButtonText: string;
    memberCode: number
}


const ReportMemberModal = NiceModal.create(({ memberCode, headerTitle, contentTitle, onNext, primaryButtonText, seconderyButtonText }: ActionModalProps) => {
    const location = useLocation();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [complaintsType, setComplaintsType] = useState<ComplaintType[]>([]);
    const [selectedComplaint, setSelectedComplaint] = useState<number>(-1);
    const [complaintText, setComplaintText] = useState<string>("");
    const modal = useModal();
    const openModalHashStateId = `${location.pathname}${location.search}&popup=reportOnMember`;
    const member = useSelector((state: RootState) => state.member)

    useLayoutEffect(() => {
        const listen = history.listen(historyBack);
        if (modal.visible) {
            window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `${openModalHashStateId}`)
        }
        return () => listen();
    }, [modal.visible])

    const historyBack = () => {
        modal.remove();
    }

    const handleModalToggle = () => {
        history.goBack();
        modal.remove();
    };

    const handleOnNext = () => {
        onNext(selectedComplaint, complaintText);
    }

    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async () => {
        setIsLoading(true);
        const { data } = await getComplaintsType(member.memberCode);
        setComplaintsType(data);
        setIsLoading(false);

    }

    const handleSelectedComplaint = (value: number) => {
        setSelectedComplaint(value);
        setComplaintText("");
    }

    const enabled = selectedComplaint !== -1;


    return (
        <>
            <div>
                <Dialog
                    sx={{ "& .MuiDialog-paper": { borderRadius: '12px', overflowY: "unset" } }}
                    open={modal.visible}
                    onClose={handleModalToggle}
                >
                    <a className={styles.modalClose} onClick={handleModalToggle}>
                        &times;
                    </a>
                    <DialogTitle className={styles.modalHeader}>

                        {headerTitle}
                    </DialogTitle>
                    <DialogContent className={styles.modalContent}>
                        {
                            isLoading ?
                                <div style={{ margin: "auto", display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                    <Loader type="ThreeDots" color="#f47373" height={60} width={60} />
                                </div>
                                :
                                <>
                                    {complaintsType.map((complaint, index) => {
                                        const isSelected = selectedComplaint === complaint.complaintId;
                                        const onPress = () => isSelected ? handleSelectedComplaint(-1) : handleSelectedComplaint(complaint.complaintId);
                                        return <div key={complaint.complaintId} style={{ display: "flex", flexDirection: "column" }}>
                                            <ComplaintTypeSelect
                                                text={complaint.complaintName}
                                                onPress={onPress}
                                                isSelected={isSelected}
                                            />
                                        </div>
                                    })}
                                    {
                                        selectedComplaint !== -1 ?
                                            <div style={{ paddingTop: 5 }}>
                                                <textarea value={complaintText} onChange={e => setComplaintText(e.target.value)} placeholder="אם נוח לך לשתף, נשמח לשמוע ממך מה קרה." className="txt_field area w-input"></textarea>
                                            </div>
                                            : null

                                    }
                                </>

                        }

                    </DialogContent>
                    <DialogActions
                        style={{ display: "flex", flexDirection: "column" }}
                    >

                        <button disabled={!enabled} onClick={handleOnNext} className={enabled ? "button_full w-button" : "button_full send w-button"}>{primaryButtonText}</button>
                        <a style={{ textDecoration: "underline", color: "black" }} onClick={handleModalToggle} className="">{seconderyButtonText}</a>

                    </DialogActions>
                </Dialog>
            </div>
        </>


    )
})


export default ReportMemberModal;